module.exports = __webpack_public_path__ + "img/icon-clipboard.42c57af3.svg";